import React, { useCallback, useEffect, useRef } from 'react';
import { LazyComponent } from '@fiverr-private/orca';
import { SafeComponent } from '../../../../shared/SafeComponent';
import { REALTIME_NOTIFICATION_LOG_MODULE } from '../../../shared/constants';
import { RealtimeSocket } from './types';
import useJobPostMatchController from './hooks/useJobPostMatchController';
import { snoozeAgenticBriefMatch } from './api/snoozeAgenticBriefMatch';

const lazyImport = () => import(/* webpackChunkName: 'JobPostMatchModal' */ './JobPostMatchModal');

interface JobPostMatchProps {
    socket: RealtimeSocket;
}

const JobPostMatch = ({ socket }: JobPostMatchProps) => {
    const { isOpen, jobPost, close, onNewNotification } = useJobPostMatchController();

    const onNewNotificationRef = useRef(onNewNotification);
    onNewNotificationRef.current = onNewNotification;

    useEffect(() => socket.subscribe((notification) => onNewNotificationRef.current(notification)), [socket]);

    const onRemind = useCallback(() => {
        snoozeAgenticBriefMatch(jobPost);
        close();
    }, [jobPost, close]);

    return (
        <LazyComponent
            lazyImport={lazyImport}
            shouldImport={isOpen}
            componentProps={{
                isOpen,
                jobPost,
                onClose: close,
                onRemind,
                onView: close,
                onExpire: close,
            }}
        />
    );
};

export default SafeComponent(REALTIME_NOTIFICATION_LOG_MODULE, 'JobPostMatch')(JobPostMatch);
